module.exports = __webpack_public_path__ + "img/制御工学6_10.b78b9b62.png";